
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.704 17.206c-1.89-.153-3.772-1.015-5.05-2.527-.598-1.101 1.037-1.76 1.537-.74 2.022 1.913 5.24 2.119 7.462.475 1.892-1.33 2.957-3.811 2.692-6.205-.277-2.998-2.707-5.552-5.526-5.8-2.278-.256-4.619.96-5.825 3.035-.786 1.23-.96 2.753-.944 4.204.639-.76.676-.752 1.347-1.48.825-.767 1.978-.018 1.216.784-4.009 4.532-3.095 4.744-6.541.094C-.392 7.86.824 7.241 1.5 8.248c.402.481.545.616.944 1.1.01-1.91.39-3.928 1.598-5.408C5.758 1.508 8.786.257 11.592.822c3.114.558 5.727 3.34 6.251 6.658.524 2.968-.618 6.182-2.883 8.006-1.478 1.243-3.384 1.829-5.256 1.72z"}}),_c('path',{attrs:{"d":"M9.16 8.498c.015-.956-.024-1.927.026-2.874-.014-.844 1.552-.768 1.531.11.004 1.224-.002 2.7.002 3.924 1.035.022 2.128.045 3.155.11.679.016.723 1.53-.034 1.512-1.385.062-2.79.017-4.183.038-.33-.004-.506-.117-.503-.463l.005-2.357z"}})])
          )
        }
      }
    